<template>
  <div>
    <div
      v-for="(item, index) in data"
      :key="index"
      :class="$style.listItem"
      @click="onSelect(item)"
      v-test="`filterList-${index}`"
    >
      <BaseIcon
        :name="item.icon"
        size="s"
      />
      {{ item.name }}
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  emits: ['select'],
  methods: {
    onSelect(item) {
      this.$emit('select', item);
    },
  },
});
</script>

<style
  lang="scss"
  module
>
.listItem {
  @include floating-list-item-inner;
  gap: $spacing * .5;
  cursor: pointer;
  border-bottom: 1px solid var(--color-border);

  @include hover {
    background-color: var(--color-highlight);
  }
}
</style>
